import { render, staticRenderFns } from "./ErrorTitleItem.vue?vue&type=template&id=2428d462&scoped=true&"
import script from "./ErrorTitleItem.vue?vue&type=script&lang=js&"
export * from "./ErrorTitleItem.vue?vue&type=script&lang=js&"
import style0 from "./ErrorTitleItem.vue?vue&type=style&index=0&id=2428d462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2428d462",
  null
  
)

export default component.exports